import { render } from "./cwc_immunization.vue?vue&type=template&id=70f472ec&scoped=true"
import script from "./cwc_immunization.vue?vue&type=script&lang=js"
export * from "./cwc_immunization.vue?vue&type=script&lang=js"

import "./cwc_immunization.vue?vue&type=style&index=0&id=70f472ec&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70f472ec"]])

export default __exports__